module.exports = __webpack_public_path__ + "static/media/hendery-6.jpeg";